import React, { PropTypes } from 'react';
import Related from '../../containers/Related';
import Modal from '../../containers/Modal';
import ImageList from '../../containers/ImageList';
import { getContentImage } from '../../ui-helpers';
import ContentBody from '../../containers/ContentBody';

const Essay = ({ id, body, title, edition, mainImage, images, subtitle }) => {
  const image = getContentImage(mainImage);
  const backgroundImage = {
    backgroundImage: `url(${image})`,
    marginBottom: '30px',
    paddingTop: '67.058823529412%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: edition.background,
  };
  const style = {
    color: edition.background,
  };
  const conditionalClass = images.length > 0 ? 'content-col--w-side' : '';

  return (
    <div className="fold fold--essay fold--main fold--main--without-index">
      <div className="fold--main__inner">
        <Modal background={edition.background} />
        <article className="fold__col fold__col--main">
          <div className={`content-col ${conditionalClass}`}>
            <header className="fold__col__header">
              <h1 className="fold__col__title">{ title }</h1>
            </header>
            <div className="content-col__main">
              <div className="scroll-wrapper">
                <div className="fold__col__body">
                  {
                    typeof mainImage !== 'undefined' ?
                      <div className="field-main-image" style={backgroundImage} /> :
                      null
                  }
                  {
                    typeof subtitle !== 'undefined' ?
                      <h2 style={style} className="field-sub-title">{ subtitle }</h2> :
                      null
                  }
                  <ContentBody background={edition.background} body={body} />
                </div>
              </div>
            </div>
            {
              images.length > 0 ?
              (<div className="content-col__side">
                <div className="scroll-wrapper">
                  <div className="fold__col__side">
                    <div className="OpencallInfo">
                      <ImageList images={images} title={title} />
                    </div>
                  </div>
                </div>
              </div>) :
              null
            }
          </div>
          <Related color={edition.background} contentId={id} />
        </article>
      </div>
    </div>
  );
};

export default Essay;

Essay.propTypes = {
  id: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
  subtitle: PropTypes.string,
  mainImage: PropTypes.string,
  images: PropTypes.arrayOf(PropTypes.object),
};

Essay.defaultProps = {
  subtitle: undefined,
  mainImage: undefined,
  images: [],
};



// WEBPACK FOOTER //
// ./js/components/happenings/Essay.js